import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GlobalService } from "./global.service";

@Injectable({
  providedIn: "root"
})
export class SearchService {
  constructor(private http: HttpClient, private api: GlobalService) {}

  searchProduct(
    offset,
    keyword,
    brandName,
    deviceType = "phones",
    sortDatePrice = "new"
  ) {
    !brandName ? (brandName = "") : (brandName = brandName);
    const query = `searches?limit=5&offset=${offset}&keyword=${keyword}&brand=${brandName}&deviceType=${deviceType}&sortDatePrice=${sortDatePrice}`;
    return this.http.get(this.api.endpoint + query, {
      headers: this.api.headers
    });
  }
}
